/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
// import 'date-fns';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// import moment from 'moment';
// import Typography from '@material-ui/core/Typography';
// import withStyles from '@material-ui/core/styles/withStyles';
// import MomentUtils from '@date-io/moment';
// import {
//   MuiPickersUtilsProvider,
//   KeyboardDatePicker,
//   DatePicker,
// } from '@material-ui/pickers';
// import Slider from '@material-ui/core/Slider';
import useDebounce from '../../../utils/useDebounce';

const UsersToolbar = (props) => {
  const {
    setLevel,
    setStartDate,
    setFinishDate,
  } = props;

  const [startDateSearch, setStartDateSearch] = useState(null);
  const debouncedStartDate = useDebounce(startDateSearch, 500);
  useEffect(() => {
    const date = new Date(new Date(startDateSearch).toDateString());
    if (startDateSearch === '' || (date instanceof Date && !Number.isNaN(date.valueOf()))) {
      setStartDate(startDateSearch);
    }
  }, [debouncedStartDate]);

  const [finishDateSearch, setFinishDateSearch] = useState(null);
  const debouncedFinalDate = useDebounce(finishDateSearch, 500);
  useEffect(() => {
    const date = new Date(new Date(finishDateSearch).toDateString());
    if (finishDateSearch === '' || (date instanceof Date && !Number.isNaN(date.valueOf()))) {
      setFinishDate(finishDateSearch);
    }
  }, [debouncedFinalDate]);

  return (
    <div className="flex">
      <div className="px-3 md:mb-0">
        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-state">
          Level
        </label>
        <div className="relative">
          <select
            className="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
            onChange={e => setLevel(e.currentTarget.value)}
          >
            <option value="" />
            <option value="INFO">INFO</option>
            <option value="PAYERROR">PAYERROR</option>
            <option value="WARN">WARNING</option>
            <option value="ERROR">ERROR</option>
          </select>
          <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700 h-12 top-0">
            <svg
              className="fill-current h-4 w-4"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div>
        </div>
      </div>

      <div className="w-1/5 px-3 md:mb-0">
        <label
          className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          htmlFor="startDateSearch"
        >
          Start Date (yyyy-mm-dd)
        </label>
        <input
          className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
          id="startDateSearch"
          type="text"
          onChange={e => setStartDateSearch(e.target.value)}
          value={startDateSearch}
        />
      </div>

      <div className="w-1/5 px-3 md:mb-0">
        <label
          className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
          htmlFor="finishDateSearch"
        >
          Final Date (yyyy-mm-dd)
        </label>
        <input
          className="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
          id="finishDateSearch"
          type="text"
          onChange={e => setFinishDateSearch(e.target.value)}
          value={finishDateSearch}
        />
      </div>
    </div>
  );
};

UsersToolbar.propTypes = {
  setLevel: PropTypes.func.isRequired,
  setStartDate: PropTypes.func.isRequired,
  setFinishDate: PropTypes.func.isRequired,
};

UsersToolbar.defaultProps = {
};

export default UsersToolbar;
